(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["us-inventory"] && !Shopify.designMode) return;
  try {
    document.addEventListener('variant:change', function (e) {
    var variant = e.detail && (e.detail.variant || e.detail);
    if (!variant || !variant.id) return;

    document.querySelectorAll('[data-us-inventory-wrapper]').forEach(function (wrapper) {
      var productId = wrapper.id.replace('us-inventory-', '');
      var inventories = window.njInventory && window.njInventory[productId];
      if (!inventories) return;

      var qty = inventories[variant.id] || 0;
      var textEl = wrapper.querySelector('.us-inventory__text');
      if (!textEl) return;

      if (qty > 0) {
        wrapper.classList.remove('hide');
        textEl.textContent = (wrapper.dataset.textAvailable || '').replace('__QTY__', qty);
      } else {
        wrapper.classList.add('hide');
        textEl.textContent = '';
      }

    });
  });
  } catch(e) { console.error(e); }
})();

})();
